import {Skeleton} from '@chekinapp/ui';

function IVStepsSkeleton({rows = 3}: {rows?: number}) {
  return (
    <div className="overflow-hidden rounded-[var(--form-section-radius)] border border-[var(--form-section-border)] bg-[var(--form-section-bg)] [box-shadow:var(--form-section-shadow)]">
      {Array.from({length: rows}).map((_, index) => (
        <div
          key={index}
          className="flex items-center gap-4 border-t border-[var(--instruction-list-divider)] px-5 py-4 first:border-t-0"
        >
          <Skeleton className="h-11 w-11 flex-none rounded-[12px]" />
          <div className="flex flex-1 flex-col gap-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-3 w-56 max-w-full" />
          </div>
          <Skeleton className="h-[26px] w-[26px] flex-none rounded-full" />
        </div>
      ))}
    </div>
  );
}

export {IVStepsSkeleton};
